import "@/sentry"; // must be first — installs global error handlers before React boots
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "@/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{ padding: 24, fontFamily: 'system-ui', maxWidth: 560, margin: '64px auto' }}>
          <h1 style={{ fontSize: 20, marginBottom: 8 }}>Something went wrong</h1>
          <p style={{ color: '#475569', fontSize: 14, marginBottom: 16 }}>
            We've been notified and are looking into it. You can try refreshing the page.
          </p>
          <button
            onClick={resetError}
            style={{ background: '#0052FF', color: '#fff', padding: '8px 16px', borderRadius: 8, border: 0, cursor: 'pointer' }}
          >
            Try again
          </button>
          {process.env.REACT_APP_SENTRY_ENV !== 'production' && (
            <pre style={{ marginTop: 24, fontSize: 11, color: '#94A3B8', whiteSpace: 'pre-wrap' }}>
              {error?.message}
            </pre>
          )}
        </div>
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

// Register the PWA service worker (no-op in dev — see file for details).
serviceWorkerRegistration.register();
